(() => {
  const urls = document.currentScript.dataset;
  const loaded = new Set();
  const ready = new Set();
  let observer;
  const features = [
    ['wishlist', '.m-wishlist-button, .m-wishlist-count, .m-wishlist-page-content__wrapper'],
    ['compare', '.m-compare-button, .m-compare-count, .m-compare-page-content__wrapper']
  ];
  const featureSelector = features.map(([, selector]) => selector).join(', ');
  function refreshState(name) {
    if (name === 'wishlist') window.MinimogTheme?.Wishlist?.setWishlistButtonsState();
    if (name === 'compare') window.MinimogTheme?.CompareProduct?.setCompareButtonsState();
  }
  function loadFeatures() {
    features.forEach(([name, selector]) => {
      if (!document.querySelector(selector)) return;
      if (loaded.has(name)) {
        refreshState(name);
        return;
      }
      const url = urls[name + 'Url'];
      if (!url) return;
      loaded.add(name);
      const script = document.createElement('script');
      script.src = url;
      script.async = true;
      script.addEventListener('load', () => {
        ready.add(name);
        refreshState(name);
        if (ready.size === features.length) observer?.disconnect();
      }, { once: true });
      script.addEventListener('error', () => loaded.delete(name), { once: true });
      document.head.appendChild(script);
    });
  }
  let queued = false;
  function scheduleRefresh() {
    if (queued) return;
    queued = true;
    queueMicrotask(() => { queued = false; loadFeatures(); });
  }
  loadFeatures();
  document.addEventListener('shopify:section:load', scheduleRefresh);
  document.addEventListener('sd:optional-features:refresh', scheduleRefresh);
  document.addEventListener('quick-view:loaded', scheduleRefresh);
  window.MinimogEvents?.subscribe('ON_PRODUCT_LIST_UPDATED', scheduleRefresh);
  // ProductList also inserts cards without emitting a refresh event. Only watch
  // added feature controls; state/class changes must not retrigger this observer.
  observer = new MutationObserver(records => {
    if (records.some(record => Array.from(record.addedNodes).some(node =>
      node.nodeType === 1 && (node.matches(featureSelector) || node.querySelector(featureSelector))))) scheduleRefresh();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
